import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle, XCircle } from 'lucide-react';
import { setEmailConfirmedFlag } from '../../utils/auth';
import { getMe } from '../../services/notificationService';
import './EmailConfirmedPage.css';

const REDIRECT_SECONDS = 3;

const EmailConfirmedPage = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const success = params.get('success') === 'true';
  const [seconds, setSeconds] = useState(REDIRECT_SECONDS);
  const [synced, setSynced] = useState(false);

  useEffect(() => {
    if (!success) return;

    let cancelled = false;
    const sync = async () => {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          const me = await getMe();
          if (cancelled) return;
          if (me && typeof me.emailConfirmed === 'boolean') {
            setEmailConfirmedFlag(me.emailConfirmed);
          } else {
            setEmailConfirmedFlag(true);
          }
        } catch {
          if (!cancelled) setEmailConfirmedFlag(true);
        }
      } else {
        setEmailConfirmedFlag(true);
      }
      localStorage.removeItem('pendingEmail');
      if (!cancelled) setSynced(true);
    };

    sync();
    return () => { cancelled = true; };
  }, [success]);

  useEffect(() => {
    if (!success || !synced) return undefined;

    setSeconds(REDIRECT_SECONDS);
    const tick = setInterval(() => {
      setSeconds((s) => Math.max(0, s - 1));
    }, 1000);
    const redirect = setTimeout(() => navigate('/login'), REDIRECT_SECONDS * 1000);

    return () => {
      clearInterval(tick);
      clearTimeout(redirect);
    };
  }, [success, synced, navigate]);

  return (
    <div className="ec-page">
      <div className="ec-card">
        {success ? (
          <>
            <div className="ec-icon-wrap ec-icon-ok">
              <CheckCircle size={40} />
            </div>
            <h1>Email confirmed!</h1>
            <p className="ec-sub">
              {synced
                ? `Your SkillOn account is now active. Redirecting to login in ${seconds}s...`
                : 'Finalizing your account...'}
            </p>
            <button
              className="ec-btn ec-btn-primary"
              onClick={() => navigate('/login')}
            >
              Go to Login
            </button>
          </>
        ) : (
          <>
            <div className="ec-icon-wrap ec-icon-err">
              <XCircle size={40} />
            </div>
            <h1>Confirmation failed</h1>
            <p className="ec-sub">
              The link is invalid or has expired. Please request a new one.
            </p>
            <button
              className="ec-btn ec-btn-primary"
              onClick={() => navigate('/verify-email')}
            >
              Resend Confirmation
            </button>
            <button
              className="ec-btn ec-btn-ghost"
              onClick={() => navigate('/login')}
              type="button"
            >
              Back to Login
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default EmailConfirmedPage;
